
<template>
  <!--添加管理员角色-->
  <div>
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
  </div>
</template>

<script>
export default {
  name: 'addRole',
  data () {
    let decoratorOptions = {
      validateTrigger: 'blur',
      role_name: {
        rules: [
          { required: true, message: '请输入角色名' },
          { min: 2, max: 20, message: '角色名为2-20个字' }
        ]
      },
      intro: {
        validateTrigger: 'blur',
        rules: [
          { min: 2, max: 20, message: '角色描述为2-20个字' }
        ]
      }
    };
    return {
      formKey: {
        role_name: '',
        intro: ''
      },
      formList: [
        {
          label: '角色名',
          inputType: 'input',
          options: [],
          placeholder: '请输入角色名',
          props: ['role_name', decoratorOptions.role_name]
        },
        {
          label: '角色描述',
          inputType: 'input',
          options: [],
          placeholder: '请输入角色描述',
          props: ['intro', decoratorOptions.intro]
        }
      ],
      addParam: {
        url: '/role/add',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/role/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/role/',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  computed: {
  },
  mounted () {},
  methods: {
    detailResHandle (res) {
      console.log('处理详情返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/managerCenter/role/addRole.vue